var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type === 'LINK')?_c('a',{attrs:{"href":_vm.to.link,"target":"blank"}},[_vm._t("default")],2):_c('router-link',{attrs:{"to":_vm.to},nativeOn:{"click":function($event){return _vm.$emit('select-item')}}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }